export default function filterEfficiencyData(data = [], filters = {}) {
  const { estadoSelecionado = '', startDate = '', endDate = '' } = filters

  const fasesChave = ['SEM_INTERESSE', 'NAO_PARTICIPOU', 'NAO_GANHOU', 'DESCLASSIFICADO', 'GANHOS']

  const mappingFases = {
    'SEM INTERESSE': 'SEM_INTERESSE',
    'NÃO PARTICIPOU': 'NAO_PARTICIPOU',
    'NAO PARTICIPOU': 'NAO_PARTICIPOU',
    'NÃO GANHOU': 'NAO_GANHOU',
    'NAO GANHOU': 'NAO_GANHOU',
    DESCLASSIFICADO: 'DESCLASSIFICADO',
    GANHOS: 'GANHOS',
  }

  function isDateInRange(dateStr) {
    if (!dateStr) return true
    if (startDate && dateStr < startDate) return false
    if (endDate && dateStr > endDate) return false
    return true
  }

  // Filtrar dados pelos filtros
  const dadosFiltrados = data.filter(item => {
    if (estadoSelecionado && item.stateName !== estadoSelecionado) return false

    // Garantir que item.date existe e extrair apenas a parte da data sem o tempo
    const itemDate = item.date ? item.date.split('T')[0] : null
    if (!isDateInRange(itemDate)) return false

    return true
  })

  const result = {
    SEM_INTERESSE: 0,
    NAO_PARTICIPOU: 0,
    NAO_GANHOU: 0,
    DESCLASSIFICADO: 0,
    GANHOS: 0,
    tempos: {},
  }

  dadosFiltrados.forEach(item => {
    let faseRaw = item.phase || ''
    faseRaw = faseRaw.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

    const faseKey = mappingFases[faseRaw]
    if (faseKey && fasesChave.includes(faseKey)) {
      result[faseKey] += 1

      if (!result.tempos[faseKey]) {
        result.tempos[faseKey] = { totalHoras: 0, count: 0 }
      }

      // Calcula horas a partir do campo time
      if (item.time) {
        const [hours, minutes, seconds] = item.time.split(':').map(Number)
        const totalHoras = hours + (minutes / 60) + (seconds / 3600)
        result.tempos[faseKey].totalHoras += totalHoras
        result.tempos[faseKey].count += 1
      }
    }
  })

  Object.keys(result.tempos).forEach(fase => {
    const { totalHoras, count } = result.tempos[fase]
    result.tempos[fase] = count > 0 ? (totalHoras / count).toFixed(1) : 'N/A'
  })

  return result
}
